<div class="relative" *transloco="let t">
	<button class="absolute right-2 top-2 z-10" mat-icon-button mat-dialog-close [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<h1 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">{{ t('uvi.refreshDialogTitle') }}</h1>
	<mat-dialog-content>{{ t('uvi.refreshDialogBody') }}</mat-dialog-content>
	<mat-dialog-actions class="flex flex-row justify-end items-center" mat-dialog-actions>
		<button [mat-dialog-close]="'realEstate'" class="m-2" color="primary" mat-dialog-close mat-raised-button>
			{{ t('uvi.refreshRealEstate') }}
		</button>
		<button [mat-dialog-close]="'tenantUnit'" class="m-2" color="primary" mat-dialog-close mat-raised-button>
			{{ t('uvi.refreshTenantUnit') }}
		</button>
	</mat-dialog-actions>
</div>
